import { mainSiteUrl } from '@/mocks/categories';

export default function CTASection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 relative overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Bright%20modern%20shopping%20concept%20with%20colorful%20shopping%20bags%20and%20gift%20boxes%20on%20a%20clean%20white%20surface%2C%20fresh%20flowers%20and%20green%20leaves%20as%20accents%2C%20natural%20sunlight%2C%20joyful%20consumer%20lifestyle%20photography%2C%20vibrant%20yet%20elegant%20aesthetic%2C%20warm%20cheerful%20atmosphere&width=1600&height=600&seq=cta-v2-section&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-white/65 backdrop-blur-[1px]"></div>
      </div>

      <div className="relative z-10 max-w-2xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-gray-900 mb-4">
          Ready to Explore the Full Collection?
        </h2>
        <p className="text-gray-700 text-sm md:text-base mb-8 max-w-lg mx-auto">
          Visit our main website to browse thousands of products across all categories with the help of your BaseTao Spreadsheet research.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-white font-semibold text-sm rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer shadow-sm"
          >
            Buy It Now
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-gray-900 text-white font-semibold text-sm rounded-full hover:bg-gray-800 transition-all duration-200 whitespace-nowrap cursor-pointer shadow-sm"
          >
            Basetao Spreadsheet
          </a>
        </div>
      </div>
    </section>
  );
}